"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const common_styled_components_1 = require("../../common-styled-components");
const useFetch_1 = __importDefault(require("../../../hooks/useFetch"));
const apiUtils_1 = require("../../../util/apiUtils");
const ShipTable_1 = require("../common/tables/ShipTable");
const useMetadata_1 = require("../../../hooks/useMetadata");
const YearContext_1 = require("../../../contexts/YearContext");
const react_1 = require("react");
exports.default = () => {
    const { selectedYear } = (0, YearContext_1.useYear)();
    const [ships, _setUrl, _setBody, refresh] = (0, useFetch_1.default)("ship/ships.json", undefined, true);
    (0, react_1.useEffect)(() => {
        _setBody(JSON.stringify({ year: selectedYear }));
    }, [selectedYear]);
    const [user] = (0, useFetch_1.default)("user/data.json");
    const [metadata] = (0, useMetadata_1.useMetadata)();
    if (!metadata ||
        ships.status !== apiUtils_1.LoaderStatus.Success ||
        user.status !== apiUtils_1.LoaderStatus.Success) {
        return (0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { children: "Loading\u2026" });
    }
    return ((0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { align: "left", children: (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SectionTitle, { children: "Ships" }), (0, jsx_runtime_1.jsx)(ShipTable_1.ShipTable, { metadata: metadata, ships: ships.data, year: selectedYear, showPool: true, refresh: refresh, isInAdminTools: false, userCompanyId: user.data.company.id })] }) }) }));
};
